/**
 * CORE-1253 — ссылка уведомления «в чат практики».
 *
 * Уведомление о вопросе в чате Live (мастеру) и об ответе мастера (автору)
 * бэкенд строит как `/live/{id}?chat=live` — это его единственный контракт с
 * фронтом, названия типов в ленте и в push к этому не привязаны. Поэтому и
 * маршрут строится по ссылке: какой бы `type`/`targetType` ни пришёл, адрес с
 * `chat` ведёт на страницу Live с открытым чатом, а не на карточку события,
 * где чата нет (натив), и не в браузер (`Linking.openURL` на iOS).
 *
 * Разбор ручной, без `URL`: у полифилла React Native `searchParams` не везде
 * реализован. Без зависимостей от RN — проверяется под jest.
 */
export interface LiveChatLink {
  id: number;
  chat: 'live' | 'thread';
}

// Схема и хост необязательны: бэкенд кладёт и абсолютные, и относительные.
const LIVE_CHAT_LINK = /^(?:[a-z][a-z0-9+.-]*:\/\/[^/?#]*)?\/live\/(\d+)\/?\?([^#]*)/i;

export function parseLiveChatLink(raw: unknown): LiveChatLink | null {
  if (typeof raw !== 'string') return null;
  const match = LIVE_CHAT_LINK.exec(raw.trim());
  if (!match) return null;
  const id = Number(match[1]);
  if (!Number.isInteger(id) || id <= 0) return null;
  const chat = match[2]
    .split('&')
    .map(pair => pair.split('='))
    .find(([key]) => key === 'chat')?.[1];
  if (chat !== 'live' && chat !== 'thread') return null;
  return { id, chat };
}
